import { render } from "./IconNotConfirmedByInmarsat.vue?vue&type=template&id=45cd0370"
import script from "./IconNotConfirmedByInmarsat.vue?vue&type=script&lang=js"
export * from "./IconNotConfirmedByInmarsat.vue?vue&type=script&lang=js"
script.render = render

export default script